import type {FullCourse} from "@repo/sanity-utils/query-types";
import {
	appendCampusQueryParameter,
	buildConsultationUrl as buildConsultationUrlShared,
} from "@repo/utils/discoveryUrls";

type SelectedModalityOffering = NonNullable<
	NonNullable<FullCourse>["modalityOfferings"]
>[number];

export {appendCampusQueryParameter};

/**
 * Append a modality-specific schedule anchor to a course URL.
 */
export function appendScheduleAnchor(url: string, modalityName: string) {
	switch (modalityName) {
		case "video-based":
			return `${url}#schedule`;
		case "chat-based":
			return `${url}#course-schedule`;
		case "in-person":
			return `${url}#available-sessions`;
		default:
			return url;
	}
}

/**
 * Build a consultation URL with a campus query parameter.
 * Video-based modalities use the Zoom scheduler instead of contact-us.
 */
export function buildConsultationUrl(
	academyUrl: string,
	campusId: string | null,
	selectedModalityOffering?: SelectedModalityOffering | null
) {
	if (selectedModalityOffering?.modality?.slug?.current === "video-based") {
		return "https://scheduler.zoom.us/d/gmzq1cj7/aops-consultation";
	}

	return buildConsultationUrlShared(academyUrl, campusId);
}

/**
 * Build the AoPS placement test URL.
 */
export function buildPlacementTestUrl(aopsUrl: string) {
	const baseUrl = aopsUrl.replace(/\/+$/, "");
	return `${baseUrl}/placement`;
}
